function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 12.6V7.69995H14V14H0V7.69995H1.4V12.6H12.6Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M166.6 -85.4H-119V99.4H166.6V-85.4Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_27937_6468)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 5.94995H-1.75V15.75H15.75V5.94995Z",
  fill: "#8A93A6"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.30078 7.69995L6.30078 -4.86374e-05H7.70078L7.70078 7.69995H9.80078L7.00078 11.2L4.20078 7.69995L6.30078 7.69995Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M-152.6 96.6L133 96.6L133 -88.2L-152.6 -88.2V96.6Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_27937_6468)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.45078 12.95L11.5508 12.95L11.5508 -1.75005L2.45078 -1.75005L2.45078 12.95Z",
  fill: "#8A93A6"
}));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27937_6468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 14,
    height: 7
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27937_6468)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_27937_6468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -119,
    y: -86,
    width: 286,
    height: 186
  }, _ref3), _ref4), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_27937_6468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 6,
    height: 12
  }, _ref5), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_27937_6468)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_27937_6468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -153,
    y: -89,
    width: 286,
    height: 186
  }, _ref6), _ref7));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.49e18584.svg";
export { ForwardRef as ReactComponent };